import { useGLTF } from '@react-three/drei';
import { useEffect } from 'react';

export const Tower = () => {
  const gltf = useGLTF('/models/buildings/blue/building_tower_B_blue.gltf');

  useEffect(() => {
    gltf.scene.traverse((child: any) => {
      if (child.isMesh) {
        child.castShadow = true;
      }
    });
  }, [gltf]);

  return <primitive object={gltf.scene} position={[2, 0, -3.4]} scale={[1, 1, 1]} castShadow />;
};
